import { List } from "@mui/material";
import React from "react";
import { useAppSelector } from "../../redux/hooks";
import { Alert } from "../../typeDefs/configuration";
import AlertListItem from "./AlertListItem";

const AlertsList = () => {
    const { alerts, alertsLoading } = useAppSelector((state) => state.config);

    return (
        <List sx={{ p: 0 }}>
            {!alertsLoading &&
                alerts &&
                alerts.length > 0 &&
                alerts.map((alert: Alert) => <AlertListItem alert={alert} />)}
        </List>
    );
};

export default AlertsList;
